import { FC } from "react";
import { useEditor, EditorContent, BubbleMenu } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Highlight from "@tiptap/extension-highlight";
import { MenuBar } from "./MenuBar";
import { BubbleMenuBar } from "./BubbleMenuBar";

interface Props {
  content?: string;
  onUpdate?(content): void;
}

export const TextEditor: FC<Props> = ({ content, onUpdate }) => {
  const editor = useEditor({
    editorProps: {
      attributes: {
        class: "px-3 py-3",
      },
    },
    extensions: [StarterKit, Link, Highlight],
    content,
    onUpdate({ editor }) {
      onUpdate(editor.getHTML());
    },
  });

  return (
    <div>
      <div className="py-0.5 border-b border-gray-300">
        <MenuBar editor={editor} />
      </div>
      <div>
        {editor && (
          <BubbleMenu
            className="bubble-menu"
            tippyOptions={{ duration: 100 }}
            editor={editor}
          >
            {/* <button
              onClick={() => editor.chain().focus().toggleBold().run()}
              className={editor.isActive("bold") ? "is-active" : ""}
            >
              Bold
            </button>
            <button
              onClick={() => editor.chain().focus().toggleItalic().run()}
              className={editor.isActive("italic") ? "is-active" : ""}
            >
              Italic
            </button>
            <button
              onClick={() => editor.chain().focus().toggleStrike().run()}
              className={editor.isActive("strike") ? "is-active" : ""}
            >
              Strike
            </button> */}
            <BubbleMenuBar editor={editor} />
          </BubbleMenu>
        )}
        <EditorContent editor={editor} />
      </div>
    </div>
  );
};
